import { render } from "./DeviceReplacer.vue?vue&type=template&id=52658e62"
import script from "./DeviceReplacer.vue?vue&type=script&lang=js"
export * from "./DeviceReplacer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__